import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import BliIconSiUspCustomerCare from '@blibli/blue-dls-library-icon/dist/UspCustomerCare'
import BliIconSiArrowLeft from '@blibli/blue-dls-library-icon/dist/ArrowLeft'
import CommonMixin from '@vue3/mixins/commonMixin.js'

export default {
  name: 'RejectedReason',
  components: {
    BliButton,
    BliIconSiUspCustomerCare,
    BliIconSiArrowLeft
  },
  mixins: [CommonMixin],
  methods: {
    logOutUser () {
      if (this.isUserMappedWithSingleTenant) {
        this.handleClearUserData()
      } else {
        this.setShowTenantPickerModal({
          showModal: true,
          isTenantAlreadySelected: false
        })
      }
    },
    handleAction () {
      this.$emit('handleCheckClick')
    }
  }
}
